(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-bullets-media"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-steps-media]').forEach(function (root) {
      var steps = root.querySelectorAll('.b2b-stepsmedia__step');
      var image = root.querySelector('[data-steps-image]');
      if (!steps.length || !image) return;
      steps.forEach(function (step) {
        var btn = step.querySelector('.b2b-stepsmedia__step-btn');
        var activate = function () {
          steps.forEach(function (s) { s.classList.remove('is-active'); });
          step.classList.add('is-active');
          var newSrc = step.getAttribute('data-step-image');
          if (newSrc) {
            image.style.opacity = '0.4';
            setTimeout(function () { image.src = newSrc; image.style.opacity = '1'; }, 120);
          }
        };
        btn.addEventListener('click', activate);
        btn.addEventListener('mouseenter', activate);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-feature-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-feature-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-feature-tab]');
      var panels = root.querySelectorAll('[data-feature-panel]');

      function activate(index) {
        tabs.forEach(function (tab) {
          var isActive = tab.dataset.featureTab === String(index);
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });
        panels.forEach(function (panel) {
          var isActive = panel.dataset.featurePanel === String(index);
          panel.classList.toggle('is-active', isActive);
          if (isActive) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { activate(tab.dataset.featureTab); });
        tab.addEventListener('keydown', function (e) {
          var current = parseInt(tab.dataset.featureTab, 10);
          var max = tabs.length;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
            e.preventDefault();
            var next = current === max ? 1 : current + 1;
            activate(next);
            tabs[next - 1].focus();
          } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var prev = current === 1 ? max : current - 1;
            activate(prev);
            tabs[prev - 1].focus();
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-video-feature"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-b2b-video-player]').forEach(function (root) {
    var video = root.querySelector('video');
    var btn = root.querySelector('.b2b-video__play');
    if (!video || !btn) return;
    btn.addEventListener('click', function () {
      video.controls = true;
      video.play();
      root.classList.add('is-playing');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-who-we-help"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-whh-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-whh-tab]');
      var panels = root.querySelectorAll('[data-whh-panel]');
      function activate(index) {
        tabs.forEach(function (tab) {
          var isActive = tab.dataset.whhTab === String(index);
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });
        panels.forEach(function (panel) {
          var isActive = panel.dataset.whhPanel === String(index);
          panel.classList.toggle('is-active', isActive);
          if (isActive) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
        });
      }
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { activate(tab.dataset.whhTab); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
class LocalizationForm extends HTMLElement {
constructor() {
super();
this.elements = {
input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
button: this.querySelector('button'),
panel: this.querySelector('.disclosure__list-wrapper'),
};
this.elements.button.addEventListener('click', this.openSelector.bind(this));
this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
}

hidePanel() {
this.elements.button.setAttribute('aria-expanded', 'false');
this.elements.panel.setAttribute('hidden', true);
}

onContainerKeyUp(event) {
if (event.code.toUpperCase() !== 'ESCAPE') return;

this.hidePanel();
this.elements.button.focus();
}

onItemClick(event) {
event.preventDefault();
const form = this.querySelector('form');
this.elements.input.value = event.currentTarget.dataset.value;
if (form) form.submit();
}

openSelector() {
this.elements.button.focus();
this.elements.panel.toggleAttribute('hidden');
this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') ===
'false').toString());
}

closeSelector(event) {
const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
if (event.relatedTarget === null || shouldClose) {
this.hidePanel();
}
}
}

customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.getElementById('shopify-section-header');
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;
this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
var navbar = document.getElementById("navbar");
var sticky = navbar.offsetTop;
var scrollThreshold = 150;

if (window.pageYOffset >= sticky + scrollThreshold) {
navbar.classList.add("sticky")
} else if (window.pageYOffset < sticky) {
navbar.classList.remove("sticky");
}
this.currentScrollTop=0;
}

}

customElements.define('sticky-header', StickyHeader); 
  } catch(e) { console.error(e); }
})();
})();
